// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selectedOptionsContent-selectedOptionsItem-uSd:hover.selectedOptionsContent-itemPlaceholderDown-WNe {\n  display: block;\n}\n\n.selectedOptionsContent-itemContent-TZv {\n}\n\n.selectedOptionsContent-selectOptionsWrapper-L6K {\n  overflow: auto;\n}\n\n.selectedOptionsContent-btn-fu2 {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectedOptionsItem": "selectedOptionsContent-selectedOptionsItem-uSd",
	"itemPlaceholderDown": "selectedOptionsContent-itemPlaceholderDown-WNe",
	"itemContent": "selectedOptionsContent-itemContent-TZv px-3 pt-4 pb-5 text-center",
	"selectOptionsWrapper": "selectedOptionsContent-selectOptionsWrapper-L6K flex flex-wrap",
	"btn": "selectedOptionsContent-btn-fu2 text-h6"
};
export default ___CSS_LOADER_EXPORT___;
